const PORT = "https://ipclserver.herokuapp.com" || "http://localhost:3001"

export default PORT